<template>
  <div
    v-if="galleryItems.length > 1"
    class="media-gallery-dots"
  >
    <button
      v-for="item in galleryItems"
      :key="item.src"
      type="button"
      :data-dot="item.index"
      class="media-gallery-dots__dot"
      :class="{
        'media-gallery-dots__dot--active': activeItem?.src === item.src,
      }"
      @click="setItem(item.index)"
    />
  </div>
</template>

<script lang="ts" setup>
const { galleryItems, activeItem, setItem } = useUiMediaGallery()
</script>

<style src="~layers/app/components/Ui/MediaGallery/Dots.css" />
